import { Link, NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// import logo from "../../assets/icons/Logo.png";
// import logoImage from "../../assets/logo/logo.png";
// import textImage from "../../assets/logo/text.png";
import homeIcon from "../../assets/icons/home.svg";
import releasesIcon from "../../assets/icons/releases.svg";
import chartsIcon from "../../assets/icons/charts.svg";
// import PlaylistIcon from '../../assets/icons/playlist2.svg'
import exclusivesIcon from "../../assets/icons/exclusives.svg";
import remixersIcon from "../../assets/icons/remixers.svg";
import ProducerIcon from "../../assets/producer/Group.png";
import SupremeLogo from "../Common/SupremeLogo";

const navLinks = [
  { name: "Home", icon: homeIcon, path: "/home" },
  { name: "Releases", icon: releasesIcon, path: "/releases" },
  { name: "Charts", icon: chartsIcon, path: "/charts" },
  { name: "Playlists", icon: null, path: "/playlist" },
  { name: "Exclusives", icon: exclusivesIcon, path: "/exclusives" },
  { name: "Producers", icon: ProducerIcon, path: "/producer-packs" },
  { name: "Remixers", icon: remixersIcon, path: "/remixers" },
];

const SideNavbar = () => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const handleLogoClick = () => {
    if (isAuthenticated) {
      navigate("/home");
    } else {
      navigate("/");
    }
  };

  return (
    <>
      <aside
        className={`hidden lg:flex fixed top-0 left-0 h-screen sm:bg-transparent bg-[#0A0A0A] transition-transform duration-300 
  w-[220px] md:w-[240px] lg:w-[250px] xl:w-[252px] border-r border-[#1A1A1A]
   flex-col justify-between
  `}
      >
        <div>
          <div className="flex flex-col gap-[40px] px-0 pt-0 sm:pt-[10px]">
            <div className="px-4 h-[60px] w-[220px] md:w-[240px] lg:w-[208px] xl:w-[208px] justify-center flex items-center">
              {/* <img src={logo} alt="Supreme Edits" className="h-9 w-[141px]" /> */}
              <div
                className="flex items-center w-[144.58px] h-[40.64px] cursor-pointer hover:opacity-80 transition-opacity z-50"
                onClick={handleLogoClick}
              >
                {/* <div className="flex items-center w-[144.58px] h-[40.64px]">
                <img
                  src="/Supremelogo.svg"
                  alt="Logo"
                  className="object-contain w-full h-full"
                />
              </div> */}
                  <div translate="no" className="flex items-center w-[186.58px] h-[48.29px] notranslate">
                    <SupremeLogo />
                  </div>
              </div>
            </div>
            <nav className="flex flex-col gap-2">
              {navLinks.map((link, index) => (
                <NavLink
                  to={link.path}
                  key={index}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-[30px] py-[8px] text-sm md:text-[15px] xl:text-[16px] transition-all 
                     ${
                       isActive
                         ? "bg-gradient-to-r from-[#40E0D0]/50 to-transparent rounded-r-[8px] font-bold text-white"
                         : "text-[#FAFAFA] font-normal hover:bg-[#121212]"
                     }`
                  }
                >
                  {link.name === "Playlists" ? (
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-[16px] h-[16px] md:w-[17px] md:h-[17px] xl:w-[18px] xl:h-[18px] scale-[0.85]"
                    >
                      <path
                        d="M14.7499 2.02971V10.8947C14.7497 11.5551 14.5317 12.197 14.1296 12.7208C13.7275 13.2446 13.1638 13.6211 12.5259 13.7919C11.888 13.9628 11.2115 13.9183 10.6014 13.6655C9.99138 13.4127 9.48176 12.9657 9.15164 12.3937C8.82152 11.8218 8.68933 11.1569 8.77558 10.5022C8.86184 9.84749 9.1617 9.23952 9.62868 8.7726C10.0957 8.30567 10.7037 8.00587 11.3584 7.91969C12.0131 7.83351 12.678 7.96577 13.2499 8.29596V5.03046L5.74989 6.27996V11.6447C5.74989 11.6897 5.74613 11.7332 5.73864 11.7752C5.79248 12.3519 5.65405 12.9303 5.34492 13.4201C5.03579 13.91 4.57332 14.2838 4.02955 14.4834C3.48579 14.683 2.89127 14.6972 2.33863 14.5237C1.78599 14.3501 1.30627 13.9987 0.974197 13.5241C0.642125 13.0495 0.476358 12.4784 0.502722 11.8997C0.529085 11.3211 0.746099 10.7674 1.11995 10.325C1.49381 9.88255 2.0035 9.57619 2.56963 9.45364C3.13576 9.33109 3.72652 9.39924 4.24989 9.64746V3.27996C4.24984 2.92488 4.37576 2.5813 4.60525 2.31034C4.83473 2.03938 5.15289 1.85862 5.50313 1.80021L13.0031 0.550708C13.218 0.514877 13.4381 0.526267 13.6481 0.584085C13.8581 0.641903 14.0529 0.744761 14.2192 0.885511C14.3854 1.02626 14.519 1.20152 14.6106 1.39912C14.7023 1.59671 14.7498 1.81189 14.7499 2.02971ZM3.12489 10.8947C2.82652 10.8947 2.54037 11.0132 2.32939 11.2242C2.11841 11.4352 1.99989 11.7213 1.99989 12.0197C1.99989 12.3181 2.11841 12.6042 2.32939 12.8152C2.54037 13.0262 2.82652 13.1447 3.12489 13.1447C3.42325 13.1447 3.7094 13.0262 3.92038 12.8152C4.13136 12.6042 4.24989 12.3181 4.24989 12.0197C4.24989 11.7213 4.13136 11.4352 3.92038 11.2242C3.7094 11.0132 3.42325 10.8947 3.12489 10.8947ZM11.7499 9.39471C11.3521 9.39471 10.9705 9.55274 10.6892 9.83405C10.4079 10.1154 10.2499 10.4969 10.2499 10.8947C10.2499 11.2925 10.4079 11.6741 10.6892 11.9554C10.9705 12.2367 11.3521 12.3947 11.7499 12.3947C12.1477 12.3947 12.5292 12.2367 12.8105 11.9554C13.0919 11.6741 13.2499 11.2925 13.2499 10.8947C13.2499 10.4969 13.0919 10.1154 12.8105 9.83405C12.5292 9.55274 12.1477 9.39471 11.7499 9.39471ZM13.2499 2.02971L5.74989 3.27996V4.75971L13.2499 3.50946V2.02971Z"
                        fill="#FAFAFA"
                      />
                    </svg>
                  ) : (
                    <img
                      src={link.icon}
                      alt={`${link.name} icon`}
                      className="w-[16px] h-[16px] md:w-[17px] md:h-[17px] xl:w-[18px] xl:h-[18px]"
                    />
                  )}
                  {link.name}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>

        <div className="text-center text-[8px] text-[#979798] px-4 pb-4">
          © 2026 Supreme Edits. All rights reserved.
        </div>
      </aside>
    </>
  );
};

export default SideNavbar;
